module.exports = __webpack_public_path__ + "img/13.da4d7f13.jpg";